import {dayMonthYearAtTime} from "../../utils/dates";

export const formatStringToCnpj = (str) => {
  
  if (str.length < 14) {
    return str
  }

  let cnpj = str

  const cnpjIntervals = [2, 3, 3, 4, 2]
  
  let cnpjToMount = []
  
  for (let i  in cnpjIntervals) {
    cnpjToMount.push(cnpj.slice(0, cnpjIntervals[i]))
    cnpj = cnpj.replace(cnpj.slice(0, cnpjIntervals[i]), '')
  }

  return `${cnpjToMount[0]}.${cnpjToMount[1]}.${cnpjToMount[2]}/${cnpjToMount[3]}-${cnpjToMount[4]}`
}

class MovmentOrderPortalListGrid {

  title = 'Checkpoint';
  
  defaultSort = 'code,ASC';

  columns = [
    {
      Header: "Operação",
      accessor: "rota",
      Cell: row => row.original && row.original.rota
    },
    {
      Header: "Ordem de Movimentação",
      accessor: "code",
      Cell: row => row.original && row.original.code
    },
    {
      Header: "Destino",
      accessor: "movementOrders.destination.friendlyName",
      Cell: row => row.original.destination && row.original.destination.friendlyName
    },
    {
      Header: "CNPJ",
      accessor: "movementOrders.destination.erpCode",
      Cell: row => row.original.destination && formatStringToCnpj(row.original.destination.erpCode)
    },
    {
      Header: "Data Doc",
      accessor: "movementOrders.createdAt",
      Cell: row => row.original.createdAt && dayMonthYearAtTime(row.original.createdAt)
    },
    {
      Header: "Tipo Viagem",
      accessor: "movementOrders.tipoRota",
      Cell: row => row.original && row.original.tipoRota
    },
  ];

  endpoint = `ton/v1/movement-orders`;
}

export default MovmentOrderPortalListGrid;



// WEBPACK FOOTER //
// ./src/pages/PortalPage/MovmentOrderPortalListGrid.js